import {dbClear, dbGetAll} from "./db-util";
import i18n from "i18next";
import {useCallback} from "react";
import moment from "moment/moment";

const useI18n = () => {
  const handleI18n = useCallback((db, i18nBundle, locale) => {
    const tx = db.transaction("i18n", "readwrite");
    const store = tx.objectStore("i18n");

    let clearI18nPromise = Promise.resolve();

    if (i18nBundle.namespaces) {
      clearI18nPromise = dbClear(store)
        .then(() => Object.keys(i18nBundle.namespaces).forEach(k => store.put({ns: k, ...i18nBundle.namespaces[k]})));
    }

    return clearI18nPromise
      .then(() => dbGetAll(store))
      .then(result => {
        result.forEach(tn => i18n.addResourceBundle(locale, tn.ns, tn, false, true));

        const txConfig = db.transaction("config", "readwrite");
        const storeConfig = txConfig.objectStore("config");

        storeConfig.put(i18nBundle.version, "i18nv");
      });
  }, []);

  const changeLanguage = useCallback(locale => {
    moment.locale(locale);

    return i18n.changeLanguage(locale);
  }, []);

  return {handleI18n, changeLanguage}
};

export default useI18n;
